<template>
  <div>
    {{$t("views.excmnotificationmessage.legend.legend")}}:
    <ul>
      <li>{{$t("views.appconfiguration.invoiceConfiguration.invoiceLegend.agreement_balance")}}</li>
      <li>{{$t("views.appconfiguration.invoiceConfiguration.invoiceLegend.debt_delay")}}</li>
      <li>{{$t("views.appconfiguration.invoiceConfiguration.invoiceLegend.buyer_name")}}</li>
      <li>{{$t("views.appconfiguration.invoiceConfiguration.invoiceLegend.to_pay")}}</li>
      <li>{{$t("views.appconfiguration.invoiceConfiguration.invoiceLegend.number")}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contentFieldInvoicesLegend'
}
</script>
